// window.$ = window.jQuery = require("jquery");
import Swiper, {Scrollbar} from 'swiper';
import 'swiper/swiper-bundle.css';

//! Toggles mobile-sticky menu on scroll
window.addEventListener("scroll", function() {
	const stickyMenu = document.getElementById("sticky-menu");
	
	if (this.scrollY > 131) {
		stickyMenu.style.maxHeight = "131px";
	}
	else {
		stickyMenu.style.maxHeight = "0px";
	}
});

//! Library Initializations
Swiper.use(Scrollbar);

new Swiper('.swiper-container', {
	slidesPerView: "auto",
	freeMode: true,
	scrollbar: {
        el: '.swiper-scrollbar',
        // hide: true,
    },
});